import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSidebar } from '../contexts/SidebarContext';
import { registerShortcut, handleKeyDown } from '../utils/keyboard';
import { dashboardPanelHref } from '../constants/dashboardPanels';
export function useKeyboardShortcuts() {
    const navigate = useNavigate();
    const { toggle: toggleSidebar } = useSidebar();
    useEffect(() => {
        const cleanups = [
            // Cmd+K is owned by CommandPalette.tsx — do not register here
            registerShortcut({ key: 'gd', handler: () => navigate('/'), description: 'Go to Dashboard' }),
            registerShortcut({ key: 'gl', handler: () => navigate(dashboardPanelHref('library')), description: 'Go to Library' }),
            registerShortcut({ key: 'gr', handler: () => navigate(dashboardPanelHref('reviews')), description: 'Go to Reviews' }),
            registerShortcut({ key: '[', handler: toggleSidebar, description: 'Toggle sidebar' }),
        ];
        window.addEventListener('keydown', handleKeyDown);
        return () => {
            cleanups.forEach(fn => fn());
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [navigate, toggleSidebar]);
}
